import React from 'react';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { OrderedMap, Map } from 'immutable';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import DownloadHelper from 'shared/lib/downloadHelper';
import ModalActions from 'shared/flux/actions/ModalActions';
import FullScreenModalActions from 'shared/flux/actions/FullScreenModalActions';
import PDFExportFormActions from 'flux/actions/cuesheet.printable/PDFExportFormActions';
import UIRegions from 'shared/constants/UIRegions';
import role from 'shared/lib/role';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import CuesheetMixin from 'main/components/show/cuesheet/cuesheetMixin';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';

export const menuId = 'cs-share-menu';

export default React.createClass({
  displayName: 'ShareMenu',

  mixins: [PureRenderMixin, CuesheetMixin],

  render() {
    const { showMenu } = this.props;

    return (
      <PopoverMenu
        className="cs-share-menu"
        config={this._getConfigData()}
        show={showMenu}
      />
    );
  },

  _getConfigData() {
    const { user, params } = this.props;
    const { eventId, teamId } = params;

    const displayPrivateNotes = { privateNotesPopulated: 'true' };

    const hasEventAdmin = role.hasEventAdminRole(user, teamId, eventId);

    let items = OrderedMap({
      exportPDF: Map({
        //Hide this item if feature not enabled OR we're in the Global ELement Manager
        hidden: isGlobalElementManager(),
        content: <p>PDF Export</p>,
        onClick: () => this._handlePDFExportV3Click(),
      }),
      wordExport: Map({
        hidden: isGlobalElementManager(),
        content: (
          <WithTooltip placement="left" tip={TooltipConstants.WordExportShare}>
            <p>Word Export</p>
          </WithTooltip>
        ),
        onClick: () => this._handleWordExportClick(),
      }),
      downloadXLSPersonal: Map({
        hidden: isGlobalElementManager(),
        content: (
          <WithTooltip
            placement="left"
            tip={TooltipConstants.CSPersonalXLSExport}
          >
            <p>XLS Export</p>
          </WithTooltip>
        ),
        onClick: () => {
          DownloadHelper.downloadPersonalXLS(params, displayPrivateNotes);
        },
      }),
      advancedExport: Map({
        hidden: isGlobalElementManager(),
        content: <p>Advanced Export</p>,
        onClick: () => this._handleAdvancedExportClick(),
      }),
      guestPass: Map({
        hidden: !hasEventAdmin,
        content: (
          <WithTooltip placement="left" tip={TooltipConstants.CSGuestPass}>
            <p>Guest Pass</p>
          </WithTooltip>
        ),
        onClick: () => this._handleGuestPassClick(),
      }),
    });

    items = items.filter((item) => item.get('hidden') !== true);

    return Map({
      id: menuId,
      noCaret: false,
      icon: 'download',
      iconSize: 2,
      placement: 'bottom',
      onClick: () => PopoverActions.show(menuId),
      onHide: () => PopoverActions.hide(menuId),
      items,
    });
  },

  _handleAdvancedExportClick() {
    ModalActions.show(UIRegions.ExportForm);
  },

  _handlePDFExportV3Click() {
    PDFExportFormActions.submit();
    FullScreenModalActions.show(UIRegions.ExportPDFV3Form);
  },

  _handleWordExportClick() {
    ModalActions.show(UIRegions.WordExportForm);
  },

  _handleGuestPassClick() {
    ModalActions.show(UIRegions.GuestPass);
  },
});
